/**
 * Gets all descendant node Account IDs for a given parent node
 */
export const getDescendants = (parentId, hierarchyData, recursive = true) => {
	const fullNodeData = hierarchyData[parentId];

	if (!fullNodeData || !fullNodeData.children) return [];

	let descendants = [...fullNodeData.children];

	if (recursive) {
		for (const child of fullNodeData.children) {
			const childDescendants = getDescendants(child, hierarchyData, recursive);
			descendants = [...descendants, ...childDescendants];
		}
	}

	return descendants;
};
